import React, { createContext, useContext, useState, ReactNode } from 'react';

// Define the type for the context value
interface UseCelsiusContextType {
    useCelsius: boolean;
    setUseCelsius: (on: boolean) => void;
}

const UseCelsiusContext = createContext<UseCelsiusContextType | undefined>(undefined);

// Create a provider component
interface UseCelsiusProviderProps {
    children: ReactNode; // Define the type of children
}

export const UseCelsiusProvider: React.FC<UseCelsiusProviderProps> = ({ children }) => {

    const [useCelsius, setUseCelsius] = useState(false);

    return (
        <UseCelsiusContext.Provider value={{ useCelsius, setUseCelsius }}>
            {children}
        </UseCelsiusContext.Provider>
    );
};

// Create a custom hook to access the context
export const useCelsiusContext = (): UseCelsiusContextType => {
  const context = useContext(UseCelsiusContext);
  if (!context) {
    throw new Error('useCelsiusContext must be used within a UseCelsiusContextProvider');
  }
  return context;
};
